export enum DiagramConnectionType {
    LINE = "LINE",
    RELATIONSHIP = "RELATIONSHIP",
}